// @flow

import React, { useContext } from "react";
import { Form } from "react-final-form";
import { useHistory, withRouter } from "react-router-dom";
import {
  FormRow,
  FieldControl,
  Select,
  Button,
  ConditionalSubform,
  formConditions,
  TextAreaWithCounter,
  validators,
  errors
} from "buba-components-ts";

import { FlashMessageContext, type AddMessage } from "buba-components";
import styles from "./BankInquiryDashboard.scss";
import { CREATOR_FEEDBACK, CREATOR_FEEDBACK_DETAILS } from "./formFields";
import { setCreatorFeedbackV2 } from "../../api/v2actions";
import paths from "../../data/paths";

const creatorFeedbackValues = {
  POSITIVE: "positive",
  CHANGE_REQUESTED: "change_requested",
  NEGATIVE: "negative"
};

type CreatorFeedbackModalProps = {
  inquiryId: string,
  financingProcess: { [key: string]: any }
};

const CreatorFeedbackModal = ({ inquiryId, financingProcess }: CreatorFeedbackModalProps) => {
  const { addMessage } = useContext<{ addMessage: AddMessage }>(FlashMessageContext);
  const history = useHistory();

  const onError = (status: ?number) => {
    addMessage(`Fehler beim Speichern der Rückmeldung${status ? `: ${status}` : ""}`, "failure");
  };

  return (
    <>
      <Form
        onSubmit={({
          creator_feedback,
          creator_feedback_details
        }: {
          creator_feedback: string,
          creator_feedback_details: string
        }) => {
          return setCreatorFeedbackV2({
            id: inquiryId,
            creator_feedback,
            creator_feedback_details
          })
            .then(() => {
              window.location.reload();
            })
            .catch(error => {
              onError(error.response?.status);
            });
        }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FormRow className={styles.creatorFeedbackRow}>
              <FieldControl
                name={CREATOR_FEEDBACK}
                additionalInfo="Bitte wählen Sie eine Rückmeldung aus"
              >
                {({ input }) => (
                  <div className={styles.creatorFeedback}>
                    <div className={styles.creatorFeedbackInput}>
                      <Select
                        input={input}
                        placeholder="Feedback wählen"
                        autoComplete
                        options={[
                          {
                            label: "Antrag ist vollständig und korrekt",
                            value: creatorFeedbackValues.POSITIVE
                          },
                          {
                            label: "Korrekturwunsch",
                            value: creatorFeedbackValues.CHANGE_REQUESTED
                          },
                          { label: "Kein Interesse", value: creatorFeedbackValues.NEGATIVE }
                        ]}
                      />
                    </div>
                  </div>
                )}
              </FieldControl>
            </FormRow>
            <ConditionalSubform
              condition={formConditions.fieldHasValue(
                CREATOR_FEEDBACK,
                creatorFeedbackValues.CHANGE_REQUESTED
              )}
              renderOnSatisfy={() => (
                <FormRow>
                  <FieldControl
                    name={CREATOR_FEEDBACK_DETAILS}
                    additionalInfo="Bitte geben Sie hier Ihren Korrekturwunsch ein"
                    validate={validators.combineValidators(
                      validators.required(errors.requiredField()),
                      validators.minLength(10, errors.minLengthCharacters(10)),
                      validators.maxLength(500, errors.maxLengthCharacters(500))
                    )}
                  >
                    {({ input, meta }) => (
                      <div>
                        <TextAreaWithCounter
                          input={input}
                          meta={meta}
                          maxLength={500}
                          placeholder="Korrekturwunsch"
                        />
                      </div>
                    )}
                  </FieldControl>
                </FormRow>
              )}
            />
            <div className={styles.buttonContainer}>
              <div className={styles.inquiryLink}>
                <Button
                  onClick={() => history.push(paths.bankInquiryApplication(inquiryId))}
                  variant="light"
                  size="small"
                  isDisabled={!financingProcess?.fidesMetadata?.dataAvailable}
                >
                  Zum Antrag
                </Button>
              </div>
              <div className={styles.submitButton}>
                <Button type="submit">Bestätigen</Button>
              </div>
            </div>
          </form>
        )}
      />
    </>
  );
};

export default withRouter(CreatorFeedbackModal);
